import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "./hooks/useAuth";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <ErrorBoundary>
    <AuthProvider><App /></AuthProvider>
  </ErrorBoundary>
);

// ── PWA Service Worker ────────────────────────────────────────────────────────
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then(reg => {
        console.log("[CC] Service worker registered:", reg.scope);
        // Notify users when an update is available
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          newWorker?.addEventListener("statechange", () => {
            if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
              console.log("[CC] New version available — reload to update.");
            }
          });
        });
      })
      .catch(err => console.warn("[CC] Service worker registration failed:", err));
  });
}
